import React, { Fragment, useEffect, useState } from 'react';
import './NewContactLensSelectPower.scss';
import OverlayTrigger from '../../../../CommonComponents/UIComponents/OverlayTrigger/OverlayTrigger';
import Tooltip from '../../../../CommonComponents/UIComponents/ToolTip/Tooltip';
import Dropdown from '../../Common/Dropdown';
import RightIcon from '../../../../../static/assets/svg/icon-right.svg';
import Divider from '../../../../CommonComponents/UIComponents/Divider/Divider';
import AuthModal from '../../AuthModal/AuthModalLoadable';
import { useDispatch, useSelector } from 'react-redux';
import NewCLPrescription from './NewCLPrescription';
import { getCLSavedPrescription } from '../../../../actionCreators/product';
import AuthModalNewLoadable from '../../AuthModalNew/AuthModalNewLoadable';

const handleProductList = props => {
  const { productCallsAction, updatePowerErrorList, clOpenList, isJitProduct } = props;
  if (!isJitProduct && typeof updatePowerErrorList === 'function') {
    updatePowerErrorList(clOpenList);
  }
  productCallsAction.handleClDropdownOpenList('');
};

const openDropdown = (props, data) => {
  const { productCallsAction } = props;
  productCallsAction.handleClDropdownOpenList(data);
};

const NewContactLensSelectPower = props => {
  const {
    localeInfo,
    dataLocale,
    errPowerList,
    isContactPrescription,
    contactLensData,
    isContactPrescValid,
    rightBoxValue,
    rightBox,
    leftBox,
    leftPowers,
    rightPowers,
    stateKey,
    clOpenList,
    leftBoxValue,
    leftBoxChange,
    selectedPowerFromUrl,
    isJitProduct,
    isNonJitPowerValidated,
    rightBoxChange,
    BoxedValue,
    redisCommonData,
    productData,
    checkboxToggle,
    contactLensId,
    loginStatus,
    setSelectPowerType,
    selectSavedPrescription,
    selectedSavedPrescription,
    contactPrescription,
  } = props;

  const {
    CALL_ME_LATER_FOR_EYEPOWER,
    USE_SAVED_PRESCRIPTION,
    ENTER_PRESCRIPTION_MANUALLY,
    SIX_LENS_PER_BOX_FOR_1_EYE,
    TO_LEARN_MORE,
    CLICK_HERE,
    THIS_IS_YOUR_MAIN_POWER,
    NOT_ALL_POWERS_HAVE_CYLINDER,
    ONLY_IF_YOU_HAVE_CYL,
    OD_LEFT_EYE,
    BOX,
    PLEASE_SELECT,
    OD_RIGHT_EYE,
    NUMBER_OF_BOXES_CAN_NOT_BE,
    ALL_POWER_FIELDS_ARE_MANDATORY,
    INVALID_POWERS_NOT_APPLICABLE,
    CL_POWER_CAN_BE_DIFF,
    HOW_TO_READ_YOUR_PRESCRIPTION,
    CONVERT_EYEGLASSES_POWER,
    SIGN_IN_TO_VIEW_SAVE_POWERS,
    SIGN_IN,
    SELECT_POWER,
  } = dataLocale;
  const { DONT_KNOW_MY_POWER_CHECKBOX_DISABLED } = redisCommonData;
  const { domainUrl } = localeInfo;

  const powerDataList = [
    {
      title: CALL_ME_LATER_FOR_EYEPOWER,
      showSection: !DONT_KNOW_MY_POWER_CHECKBOX_DISABLED,
    },
    {
      title: USE_SAVED_PRESCRIPTION,
      showSection: true,
    },
    {
      title: ENTER_PRESCRIPTION_MANUALLY,
      showSection: true,
    },
  ];
  const [callMeLaterChecked, setCallMeLaterChecked] = useState(false);
  const [showLogin, setShowLogin] = useState(false);
  const [showError, setShowError] = useState(false);
  const [showSubError, setShowSubError] = useState(false);
  const askUserLogin = useSelector(state => state.common.askUserLogin);
  const savedPrescription = useSelector(state => state.product.savedPrescription);
  const [expandedTab, setExpandedTab] = useState(
    loginStatus && savedPrescription && savedPrescription?.result?.length > 0
      ? USE_SAVED_PRESCRIPTION
      : ENTER_PRESCRIPTION_MANUALLY
  );

  const newLoginPopUp = !!(
    redisCommonData &&
    redisCommonData?.NEW_AUTH_POPUP_DESKTOP &&
    JSON.parse(redisCommonData?.NEW_AUTH_POPUP_DESKTOP).enable === 'ON'
  );

  const dispatch = useDispatch();

  const changeExpandedTab = (e, tabName) => {
    setExpandedTab(tabName);
    if (
      (tabName === CALL_ME_LATER_FOR_EYEPOWER && !callMeLaterChecked) ||
      (tabName !== CALL_ME_LATER_FOR_EYEPOWER && callMeLaterChecked)
    ) {
      checkboxToggle(e, contactLensId);
      setCallMeLaterChecked(!callMeLaterChecked);
    }
    if (tabName !== USE_SAVED_PRESCRIPTION) {
      selectSavedPrescription(null);
    }
    setSelectPowerType(tabName);
  };

  useEffect(() => {
    if (props.triggerFn) props.triggerFn();
    if (expandedTab === CALL_ME_LATER_FOR_EYEPOWER) {
      checkboxToggle(null, contactLensId);
      setCallMeLaterChecked(true);
    }
    setSelectPowerType(expandedTab);
    return () => {};
  }, []);

  useEffect(() => {
    if (loginStatus && !savedPrescription) dispatch(getCLSavedPrescription());
  }, [loginStatus]);

  useEffect(() => {
    if (loginStatus && savedPrescription && savedPrescription?.result?.length > 0)
      changeExpandedTab(null, USE_SAVED_PRESCRIPTION);
  }, [savedPrescription]);

  useEffect(() => {
    setShowError(true);
    setShowSubError(true);
  }, [isContactPrescValid, isContactPrescription]);

  const updateShowSubError = value => {
    setShowSubError(value);
  };

  return contactLensData?.powerTypeList?.length ? (
    <Fragment>
      <p className="cl-power-title">{SELECT_POWER}</p>
      <div className="cl-power-tabs">
        {powerDataList.map(
          (powerData, index) =>
            powerData.showSection && (
              <div key={index} className="cl-power-tab">
                <div className="cl-power-tab-header">
                  <input
                    checked={expandedTab === powerData.title}
                    className="cl-power-radio"
                    id={`cl-power-${index}`}
                    name="cl-power"
                    type="radio"
                    onChange={e => {
                      changeExpandedTab(e, powerData.title);
                      setShowError(false);
                      setShowSubError(false);
                    }}
                  />
                  <label className="cl-power-label" htmlFor={`cl-power-${index}`}>
                    {powerData.title}
                  </label>
                </div>
                {expandedTab === powerData.title && powerData.title !== CALL_ME_LATER_FOR_EYEPOWER && (
                  <div className="cl-power-tab-body">
                    {powerData.title === ENTER_PRESCRIPTION_MANUALLY && (
                      <div className="clEnterPresTab">
                        {productData &&
                          !productData?.isPlano &&
                          contactLensData?.powerTypeList?.length && (
                            <div>
                              <div className="cl-quicklinks-text">
                                <p>{CL_POWER_CAN_BE_DIFF}</p>
                              </div>
                              <div className="cl-quicklinks-links">
                                <a
                                  className="cl-quicklinks"
                                  href={`//${domainUrl}/understand-your-prescription.html`}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                >
                                  {HOW_TO_READ_YOUR_PRESCRIPTION}
                                  <img alt="right icon" src={RightIcon} />
                                </a>
                                <Divider />
                                <a
                                  className="cl-quicklinks"
                                  href={`//${domainUrl}/convert-your-eyeglasses-power.html`}
                                  rel="noopener noreferrer"
                                  target="_blank"
                                >
                                  {CONVERT_EYEGLASSES_POWER}
                                  <img alt="right icon" src={RightIcon} />
                                </a>
                              </div>
                            </div>
                          )}
                        <div className="cl-sp-container display-flex ">
                          <div
                            className="col-lg-12 col-md-12 col-sm-12 no-padding margin-t72 display-flex flex-column justify-content-center"
                            style={{ gap: '20px' }}
                          >
                            {contactLensData &&
                              contactLensData.powerTypeList &&
                              contactLensData.powerTypeList?.map((data, index) => {
                                return (
                                  <div
                                    key={index}
                                    className="col-lg-2 col-md-2 col-sm-2 padding-r0 padding-l5 width100"
                                  >
                                    <div className="contact-type-lens contact-type-heading">
                                      {data.label}
                                      {['boxes', 'sph', 'cyl', 'axis'].includes(data?.type) && (
                                        <OverlayTrigger
                                          delayHide={1000}
                                          overlay={
                                            <Tooltip id={data.type} title={data.type}>
                                              {data.type === 'boxes' && (
                                                <div>
                                                  {SIX_LENS_PER_BOX_FOR_1_EYE}. {TO_LEARN_MORE},{' '}
                                                  <a
                                                    className="text-lowercase"
                                                    href={`//${domainUrl}/understanding_lens`}
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                  >
                                                    {CLICK_HERE}.
                                                  </a>
                                                </div>
                                              )}
                                              {data.type === 'sph' && (
                                                <div>
                                                  {THIS_IS_YOUR_MAIN_POWER}. {TO_LEARN_MORE}{' '}
                                                  <a
                                                    className="text-lowercase"
                                                    href={`//${domainUrl}/understand-your-prescription.html`}
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                  >
                                                    {CLICK_HERE}.
                                                  </a>
                                                </div>
                                              )}
                                              {data.type === 'cyl' && (
                                                <div>
                                                  {NOT_ALL_POWERS_HAVE_CYLINDER}. {TO_LEARN_MORE}{' '}
                                                  <a
                                                    className="text-lowercase"
                                                    href={`//${domainUrl}/understand-your-prescription.html`}
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                  >
                                                    {CLICK_HERE}.
                                                  </a>
                                                </div>
                                              )}
                                              {data.type === 'axis' && (
                                                <div>
                                                  {ONLY_IF_YOU_HAVE_CYL}. {TO_LEARN_MORE}{' '}
                                                  <a
                                                    className="text-lowercase"
                                                    href={`//${domainUrl}/understand-your-prescription.html`}
                                                    rel="noopener noreferrer"
                                                    target="_blank"
                                                  >
                                                    {CLICK_HERE}.
                                                  </a>
                                                </div>
                                              )}
                                            </Tooltip>
                                          }
                                          placement="top"
                                          trigger={['hover', 'focus']}
                                        >
                                          <div className="power_overlay">
                                            <span className="power_overlay_tigger">?</span>
                                          </div>
                                        </OverlayTrigger>
                                      )}
                                    </div>
                                  </div>
                                );
                              })}
                          </div>
                          <div className="col-lg-12 col-md-12 col-sm-12 no-padding margin-t10 margin-b10 display-flex flex-column">
                            {contactLensData !== null &&
                              contactLensData !== undefined &&
                              contactLensData?.powerTypeList &&
                              contactLensData?.powerTypeList?.map((data, index) => {
                                return (
                                  <div
                                    key={data.type}
                                    className="col-lg-2 col-md-2 col-sm-2 padding-r0 padding-l5 width100"
                                  >
                                    {index === 0 && (
                                      <div className="contact-type-lens">{OD_LEFT_EYE}</div>
                                    )}
                                    {data.type === 'boxes' ? (
                                      <div className="select-style">
                                        <select
                                          ref={powerOptionBoxLeft => {
                                            leftBox[data.type] = powerOptionBoxLeft;
                                          }}
                                          name={data.type}
                                          placeholder="Power"
                                          value={leftBoxValue}
                                          onChange={ev => leftBoxChange(ev)}
                                        >
                                          {data.powerDataList[0].value[0] === '1' && (
                                            <option value="0">0 {BOX}</option>
                                          )}
                                          {data.powerDataList.map(mydata => {
                                            return Object.keys(mydata.value).map(key => {
                                              return (
                                                <option key={key} value={mydata.value[key]}>
                                                  {`${mydata.value[key]} ${BOX}`}
                                                </option>
                                              );
                                            });
                                          })}
                                        </select>
                                      </div>
                                    ) : (
                                      <Dropdown
                                        ref={powerOptionValueLeft => {
                                          leftPowers[data.type] = powerOptionValueLeft;
                                        }}
                                        isDisabled={leftBoxValue}
                                        name={data.type}
                                        openList={clOpenList}
                                        openedPowerTab={stateKey}
                                        power="left-power"
                                        {...props}
                                        defaultLabel={PLEASE_SELECT}
                                        handleProductList={handleProductList}
                                        list={data.powerDataList[0].value}
                                        openDropdown={openDropdown}
                                      />
                                    )}
                                  </div>
                                );
                              })}
                            {!isJitProduct &&
                              !isContactPrescValid &&
                              !isNonJitPowerValidated &&
                              isContactPrescription?.result[0]?.leftQuantityValidationError &&
                              showSubError && (
                                <div className="col-lg-10 col-md-10 col-sm-10 col-lg-offset-2 col-md-offset-2 col-sm-offset-2 padding-t5 padding-l5 text-red">{`${isContactPrescription.result[0].leftQuantityValidationError}`}</div>
                              )}
                          </div>
                          <div className="col-lg-12 col-md-12 col-sm-12 no-padding margin-t10 margin-b10 display-flex flex-column">
                            {contactLensData &&
                              contactLensData.powerTypeList &&
                              contactLensData?.powerTypeList?.map((data, index) => {
                                return (
                                  <div
                                    key={data.type}
                                    className="col-lg-2 col-md-2 col-sm-2 padding-r0 padding-l5 width100"
                                  >
                                    {index === 0 && (
                                      <div className="contact-type-lens">{OD_RIGHT_EYE}</div>
                                    )}
                                    {data.type === 'boxes' ? (
                                      <div className="select-style">
                                        <select
                                          ref={powerOptionBoxRight => {
                                            rightBox[data.type] = powerOptionBoxRight;
                                          }}
                                          name={data.type}
                                          value={rightBoxValue}
                                          onChange={ev => rightBoxChange(ev)}
                                        >
                                          {data.powerDataList.map(mydata => {
                                            return Object.keys(mydata.value).map(key => {
                                              return (
                                                <option key={key} value={mydata.value[key]}>
                                                  {' '}
                                                  {`${mydata.value[key]} ${BOX}`}
                                                </option>
                                              );
                                            });
                                          })}
                                        </select>
                                      </div>
                                    ) : (
                                      <>
                                        <Dropdown
                                          errPowerList={errPowerList}
                                          isDisabled={rightBoxValue}
                                          name={data.type}
                                          openList={clOpenList}
                                          openedPowerTab={stateKey}
                                          power="right-power"
                                          {...props}
                                          ref={powerOptionValueRight => {
                                            rightPowers[data.type] = powerOptionValueRight;
                                          }}
                                          defaultLabel={PLEASE_SELECT}
                                          handleProductList={handleProductList}
                                          list={data.powerDataList[0].value}
                                          openDropdown={openDropdown}
                                          selectedPowerFromUrl={selectedPowerFromUrl}
                                        />
                                      </>
                                    )}
                                  </div>
                                );
                              })}
                            {!isJitProduct &&
                              !isContactPrescValid &&
                              !isNonJitPowerValidated &&
                              isContactPrescription?.result?.[0]?.rightQuantityValidationError &&
                              showSubError && (
                                <div className="col-lg-12 col-md-12 col-sm-12 padding-t5 padding-l5 text-red">{`${isContactPrescription.result[0].rightQuantityValidationError}`}</div>
                              )}
                          </div>
                        </div>
                        {!isJitProduct && errPowerList?.length > 0 && (
                          <div className=" padding-t10 padding-b10 padding-l5 text-red">
                            {ALL_POWER_FIELDS_ARE_MANDATORY}.
                          </div>
                        )}
                        <div
                          className={`${BoxedValue} padding-t10 padding-b10 padding-l5 text-red`}
                        >
                          {NUMBER_OF_BOXES_CAN_NOT_BE}
                        </div>
                      </div>
                    )}

                    {powerData.title === USE_SAVED_PRESCRIPTION && (
                      <div className="savedPrescTab">
                        {!loginStatus && (
                          <div className="use-saved-panel contact-lenskart-sign">
                            <div className="saved-prescription-sign">
                              {SIGN_IN_TO_VIEW_SAVE_POWERS}
                            </div>
                            {showLogin &&
                              (!newLoginPopUp ? (
                                <AuthModal
                                  allowSignUp
                                  askUserLogin={askUserLogin}
                                  hideLogin={() => {
                                    clearInterval(window.secondsTimer);
                                    setShowLogin(false);
                                  }}
                                  openTab="signin"
                                />
                              ) : (
                                <AuthModalNewLoadable
                                  allowSignUp
                                  handleModalClose={() => {
                                    clearInterval(window.secondsTimer);
                                    setShowLogin(false);
                                  }}
                                  hideLogin={() => {
                                    clearInterval(window.secondsTimer);
                                    setShowLogin(false);
                                  }}
                                  openTab="signin"
                                />
                              ))}
                            <button
                              className="btn-sign-in"
                              onClick={e => {
                                e.preventDefault();
                                setShowLogin(true);
                              }}
                            >
                              {SIGN_IN}
                            </button>
                          </div>
                        )}
                        {loginStatus && (
                          <NewCLPrescription
                            contactPrescription={contactPrescription}
                            dataLocale={dataLocale}
                            isJitProduct={isJitProduct}
                            selectSavedPrescription={selectSavedPrescription}
                            selectedSavedPrescription={selectedSavedPrescription}
                            showSubError={showSubError}
                            updateShowSubError={updateShowSubError}
                          />
                        )}
                      </div>
                    )}
                  </div>
                )}
              </div>
            )
        )}
      </div>
      {!isContactPrescValid && isJitProduct && showError && (
        <div className="alert alert-danger">{INVALID_POWERS_NOT_APPLICABLE}</div>
      )}
      {!isContactPrescValid &&
        !isJitProduct &&
        isNonJitPowerValidated &&
        isContactPrescription &&
        showError && (
          <div className="alert alert-danger">{`${isContactPrescription?.message}`}</div>
        )}
    </Fragment>
  ) : null;
};

export default NewContactLensSelectPower;
